import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import {
  ArrivingFailed,
  ArrivingLayout,
  ArrivingPending,
} from "@/client/components/arriving-layout";
import { pageTitle } from "@/client/lib/page-title";
import { PENDING_MS } from "@/client/lib/pending";
import { sessionQuery } from "@/client/lib/session";
import { JoinLanding } from "@/features/invitation/components/join-landing";
import { joinQuery } from "@/features/invitation/join-query";

/**
 * Outside the signed-in layout: the person holding the link may have no account yet, and this page
 * tells them which one to use.
 */
export const Route = createFileRoute("/join/$token")({
  pendingMs: PENDING_MS,
  pendingComponent: ArrivingPending,
  errorComponent: ArrivingFailed,
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(joinQuery(params.token)),
      context.queryClient.ensureQueryData(sessionQuery),
    ]),
  head: async () => {
    const { invitationCopy } = await import("@/features/invitation/copy");
    return { meta: [{ title: pageTitle(invitationCopy.join.tab) }] };
  },
  component: Join,
});

function Join() {
  const { token } = Route.useParams();
  const { data: landing } = useSuspenseQuery(joinQuery(token));
  const { data: session } = useSuspenseQuery(sessionQuery);
  return (
    <ArrivingLayout>
      <JoinLanding token={token} landing={landing} session={session} />
    </ArrivingLayout>
  );
}
